import React, {PropTypes, Component} from 'react'
import {fromJS} from 'immutable'
import {connect} from 'react-redux'
import Link from 'react-router/lib/Link'
import {Form, actions} from 'react-redux-form/immutable'
import {Fieldset, Row, Field} from 'react-gridforms'
import Mousetrap from 'mousetrap'
import Trash from 'react-icons/lib/md/delete'

import Input from 'components/Input'
import RowSearch from 'components/RowSearch'
import SearchModalSubject from 'components/SearchModalSubject'
import {searchSubject} from 'containers/Subjects/actions'
import {searchEmployee} from 'containers/Employees/actions'
import {intRequired, required} from 'utils/validators'

import ListSubjects from './list-subjects'

const validators = {
  instructor_id: {intRequired},
  section: {required},
  max_slots: {required},
}

class FormOffering extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openSearchSubject: false,
    }
  }

  componentDidMount() {
    Mousetrap.bind('s', this._openSearchSubject)
    Mousetrap.bind('p', this._submit)
  }

  componentWillUnmount() {
    Mousetrap.unbind('s', this._openSearchSubject)
    Mousetrap.unbind('p', this._submit)
  }

  // submit button shortcut key 'p'
  _submit = () => {
    if (this._submitButton) {
      this._submitButton.click()
    }
  }

  _openSearchSubject = () => {
    this.setState({
      openSearchSubject: true,
    })
  }

  _hideSearchSubject = () => {
    this.setState({
      openSearchSubject: false,
    })
  }

  _onSelectSubject = subject => {
    this.props.dispatch(
      actions.push(
        'offeringState.subjects',
        fromJS({
          id: 0,
          subject_id: subject.get('id'),
          subject_code: subject.get('code'),
          subject_name: subject.get('name'),
          curriculum_code: subject.get('curriculum_code'),
          units: subject.get('units'),
        })
      )
    )
    this.setState({
      openSearchSubject: false,
    })
  }

  _onSearchSubject = term => {
    this.props.dispatch(searchSubject(term))
  }

  _onDeleteSubject = subjectIndex => {
    this.props.dispatch(actions.remove('offeringState.subjects', subjectIndex))
  }

  _focusSched = () => {
    this._sched._input.select()
  }

  _renderButtons() {
    const {item, isShow, onDelete} = this.props
    const s = !item || item.get('id') === 0
      ? 'Save Offering'
      : 'Update Offering'

    if (isShow) {
      return (
        <div className="text-right">
          <button onClick={onDelete} type="button" className="btn btn-icon">
            <Trash />
          </button>
          {' '}
          <Link
            to={`/setup/offerings/${item.get('id')}/edit`}
            className="btn btn-default"
          >
            Edit Offering
          </Link>
        </div>
      )
    } else {
      return (
        <div className="text-right">
          <button
            ref={c => (this._submitButton = c)}
            type="submit"
            className="btn btn-success"
          >
            {s}
          </button>
        </div>
      )
    }
  }

  _renderSearchSubject() {
    const {openSearchSubject} = this.state
    const {__resultSubjects} = this.props

    if (!openSearchSubject) {
      return null
    }

    return (
      <SearchModalSubject
        placeholder="Search Subject Code"
        handleClose={this._hideSearchSubject}
        onSubmit={this._onSearchSubject}
        results={__resultSubjects}
        onSelectItem={this._onSelectSubject}
      />
    )
  }

  render() {
    const {__model, __employees, isShow, onSubmit} = this.props
    const subjectHeader = (
      <div>
        Subject/s
        {!isShow &&
          <button
            disabled={isShow}
            type="button"
            onClick={this._openSearchSubject}
            className="btn-inline btn-icon"
          >
            +
          </button>}
      </div>
    )
    return (
      <Form
        model="offeringState"
        className="grid-form offering"
        validators={validators}
        onSubmit={onSubmit}
      >
        {this._renderButtons()}
        <Fieldset legend={subjectHeader} disabled={isShow}>
          <ListSubjects
            items={__model.get('subjects')}
            isShow={isShow}
            onDelete={this._onDeleteSubject}
          />
        </Fieldset>
        <Fieldset legend="Details" disabled={isShow}>
          <RowSearch
            placeholder="Search Instructor Name OR ID"
            model="offeringState.instructor_id"
            model1="offeringState.instructor_id_input"
            model2="offeringState.instructor_name"
            label1="Instructor ID"
            label2="Instructor Name"
            onSearch={searchEmployee}
            onFinish={this._focusSched}
            results={__employees}
            disabled={isShow}
          />
          <Row>
            <Field>
              <Input
                ref={c => (this._sched = c)}
                model=".schedule"
                label="Schedule (ex. M 8:30-9:30 RM.301 | TF 15:00-16:00 RM.B14)"
              />
            </Field>
          </Row>
          <Row>
            <Field>
              <Input model=".section" label="Section" required />
            </Field>
            <Field>
              <Input
                type="number"
                model=".max_slots"
                label="Max Slots"
                required
              />
            </Field>
          </Row>
        </Fieldset>
        {this._renderSearchSubject()}
      </Form>
    )
  }
}

FormOffering.propTypes = {
  __model: PropTypes.object,
  __employees: PropTypes.object,
  __resultSubjects: PropTypes.object,
  item: PropTypes.object,
  isShow: PropTypes.bool,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __model: state.offeringState,
    __employees: state.employee.get('searchResults'),
    __resultSubjects: state.subject.get('searchResults'),
  }
}

export default connect(mapStateToProps)(FormOffering)



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/form-offering.js